/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_Bddk_BInputs */

const tr_mesafeli_s6_bddk_b = /** @type {(inputs: Mesafeli_S6_Bddk_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Yeni dönem için ödeme, Müşteri tarafından Platform içi`)
};

const en_mesafeli_s6_bddk_b = /** @type {(inputs: Mesafeli_S6_Bddk_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Payment for a new term is started by the Customer via the`)
};

const de_mesafeli_s6_bddk_b = /** @type {(inputs: Mesafeli_S6_Bddk_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Die Zahlung für eine neue Laufzeit startet der Kunde über die Seite`)
};

const ru_mesafeli_s6_bddk_b = /** @type {(inputs: Mesafeli_S6_Bddk_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Оплату нового срока Клиент начинает на странице Платформы`)
};

/**
* | output |
* | --- |
* | ". Payment for a new term is started by the Customer via the" |
*
* @param {Mesafeli_S6_Bddk_BInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_bddk_b = /** @type {((inputs?: Mesafeli_S6_Bddk_BInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_Bddk_BInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_bddk_b(inputs)
	if (locale === "de") return de_mesafeli_s6_bddk_b(inputs)
	if (locale === "ru") return ru_mesafeli_s6_bddk_b(inputs)
	return tr_mesafeli_s6_bddk_b(inputs)
});